import Login from '@auth/views/Login'
import { configuration, paths } from 'mmfintech-backend-api'
import type { RouteDefinition } from 'mmfintech-backend-api/types'
import React from 'react'

const LazyAdsRegisterPage = React.lazy(() => import('@views/adsPages/AdsRegister'))
const LazyAdsRegisterPageMCA = React.lazy(() => import('@views/adsPages/AdsRegisterMCA'))
const LazyAdsRegisterOffshoreAndOverseas = React.lazy(() => import('@views/adsPages/AdsRegisterOffshoreAndOverseas'))
const LazyError404 = React.lazy(() => import('@views/auth/Error404'))
const LazyScanAndPayP2P = React.lazy(() => import('@views/scanAndPay/PeerToPeer'))
const LazySignup = React.lazy(() => import('@views/auth/Signup'))
const LazyVerifyEmail = React.lazy(() => import('@views/auth/VerifyEmail'))

export const logoutAnd404Routes: RouteDefinition[] = [
  { path: paths.logout(), component: React.lazy(() => import('@views/auth/Logout')) },
  { path: paths.error404(), component: LazyError404 },
  { path: '*', component: LazyError404 }
]

export const nonProtectedRoutes: RouteDefinition[] = [
  { path: paths.login(), component: Login },

  { path: paths.signUp(), component: LazySignup },
  { path: paths.signUpViaInviteLink(':referralCode'), check: paths.signUpViaInviteLink('*'), component: LazySignup },
  {
    path: paths.invite(':link'),
    check: paths.invite('*'),
    component: React.lazy(() => import('@views/auth/InviteHandler'))
  },
  {
    path: paths.passwordReset(),
    component: React.lazy(() => import('@views/auth/ResetPasswordHandler'))
  },
  {
    path: paths.handlePasswordReset(),
    component: React.lazy(() => import('@views/auth/ResetPassword'))
  },
  {
    path: paths.checkEmail(),
    component: React.lazy(() => import('@views/auth/VerifyEmailMessage'))
  },
  { path: paths.handleEmailVerify(), component: LazyVerifyEmail },
  { path: paths.handleInvitationVerify(), component: LazyVerifyEmail },
  {
    path: paths.handlePasswordResetInvited(),
    component: React.lazy(() => import('@views/auth/SetPassword'))
  },
  {
    path: paths.sendMoneyP2P(':publicMerchantId([a-zA-Z0-9]{10,})'),
    component: LazyScanAndPayP2P
  },

  {
    path: paths.invoices.checkout(':magicToken'),
    check: paths.invoices.checkout('*'),
    component: React.lazy(() => import('@views/invoices/InvoiceCheckout'))
  },
  {
    path: paths.invoices.viewByToken(':magicToken'),
    check: paths.invoices.viewByToken('*'),
    component: React.lazy(() => import('@views/invoices/InvoicePreview'))
  },

  {
    path: paths.walletPayment(),
    component: React.lazy(() => import('@views/banking/WalletPayment'))
  },

  ...(configuration.isLocal()
    ? [{ path: '/test-styles', component: React.lazy(() => import('@modules/tests/WebComponentsTest')) }]
    : []),

  { path: paths.expos.webX24, component: LazySignup },
  { path: paths.expos.sigmaEE24, component: LazySignup },
  { path: paths.expos.entertainmentArena24, component: LazySignup },
  { path: paths.expos.worldFinanceForum24, component: LazySignup },
  { path: paths.expos.tes24PRG, component: LazySignup },
  { path: paths.expos.cyprusGaming24, component: LazySignup },
  { path: paths.expos.singaporeFintech24, component: LazySignup },
  { path: paths.expos.worldBlockchain24, component: LazySignup },
  { path: paths.expos.sigmaEurope24, component: LazySignup },
  { path: paths.expos.financeMagnets24, component: LazySignup },
  { path: paths.expos.globalBankingFT24, component: LazySignup },

  { path: paths.ads.b2bPayment_FC, component: LazyAdsRegisterPage },
  { path: paths.ads.b2bPayment_MT, component: LazyAdsRegisterPage },
  { path: paths.ads.b2bPayment_RD, component: LazyAdsRegisterPage },
  { path: paths.ads.b2bPayment_TC, component: LazyAdsRegisterPage },
  { path: paths.ads.b2bPayment_TW, component: LazyAdsRegisterPage },

  { path: paths.ads.bestOffshoreBankAccount, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.bestOffshoreBankAccount_A, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.bestOffshoreBankAccount_B, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.bestOffshoreBankAccount_C, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.bestOffshoreBankAccount_D, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.bestOffshoreBankAccount_E, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.bestOffshoreBankAccount_FC, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.bestOffshoreBankAccount_MT, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.bestOffshoreBankAccount_PX, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.bestOffshoreBankAccount_RD, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.bestOffshoreBankAccount_TC, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.bestOffshoreBankAccount_TCC, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.bestOffshoreBankAccount_TW, component: LazyAdsRegisterOffshoreAndOverseas },

  { path: paths.ads.businessAccount, component: LazyAdsRegisterPage },
  { path: paths.ads.businessAccount_A, component: LazyAdsRegisterPage },
  { path: paths.ads.businessAccount_B, component: LazyAdsRegisterPage },
  { path: paths.ads.businessAccount_C, component: LazyAdsRegisterPage },
  { path: paths.ads.businessAccount_D, component: LazyAdsRegisterPage },
  { path: paths.ads.businessAccount_E, component: LazyAdsRegisterPage },
  { path: paths.ads.businessAccount_FC, component: LazyAdsRegisterPage },
  { path: paths.ads.businessAccount_MT, component: LazyAdsRegisterPage },
  { path: paths.ads.businessAccount_PX, component: LazyAdsRegisterPage },
  { path: paths.ads.businessAccount_RD, component: LazyAdsRegisterPage },
  { path: paths.ads.businessAccount_TC, component: LazyAdsRegisterPage },
  { path: paths.ads.businessAccount_TCC, component: LazyAdsRegisterPage },
  { path: paths.ads.businessAccount_TW, component: LazyAdsRegisterPage },

  { path: paths.ads.cryptoFriendlyBank_FC, component: LazyAdsRegisterPage },
  { path: paths.ads.cryptoFriendlyBank_MT, component: LazyAdsRegisterPage },
  { path: paths.ads.cryptoFriendlyBank_RD, component: LazyAdsRegisterPage },
  { path: paths.ads.cryptoFriendlyBank_TC, component: LazyAdsRegisterPage },
  { path: paths.ads.cryptoFriendlyBank_TW, component: LazyAdsRegisterPage },

  { path: paths.ads.internationalBankAccount_FC, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.internationalBankAccount_MT, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.internationalBankAccount_TC, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.internationalBankAccount_TW, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.internationalBankAccount_RD, component: LazyAdsRegisterPageMCA },

  { path: paths.ads.moneyTransfer_FC, component: LazyAdsRegisterPage },
  { path: paths.ads.moneyTransfer_MT, component: LazyAdsRegisterPage },
  { path: paths.ads.moneyTransfer_RD, component: LazyAdsRegisterPage },
  { path: paths.ads.moneyTransfer_TC, component: LazyAdsRegisterPage },
  { path: paths.ads.moneyTransfer_TW, component: LazyAdsRegisterPage },

  { path: paths.ads.multicurrencyAccount, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.multicurrencyAccount_A, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.multicurrencyAccount_B, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.multicurrencyAccount_C, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.multicurrencyAccount_D, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.multicurrencyAccount_E, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.multicurrencyAccount_FC, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.multicurrencyAccount_MT, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.multicurrencyAccount_PX, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.multicurrencyAccount_RD, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.multicurrencyAccount_TC, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.multicurrencyAccount_TW, component: LazyAdsRegisterPageMCA },

  { path: paths.ads.overseasBankAccount, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.overseasBankAccount_A, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.overseasBankAccount_B, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.overseasBankAccount_C, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.overseasBankAccount_D, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.overseasBankAccount_E, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.overseasBankAccount_FC, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.overseasBankAccount_MT, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.overseasBankAccount_RD, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.overseasBankAccount_TC, component: LazyAdsRegisterOffshoreAndOverseas },
  { path: paths.ads.overseasBankAccount_TW, component: LazyAdsRegisterOffshoreAndOverseas },

  { path: paths.ads.virtualDebitCard, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.virtualDebitCard_A, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.virtualDebitCard_B, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.virtualDebitCard_C, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.virtualDebitCard_D, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.virtualDebitCard_E, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.virtualDebitCard_CZ, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.virtualDebitCard_MT, component: LazyAdsRegisterPageMCA },
  { path: paths.ads.virtualDebitCard_PX, component: LazyAdsRegisterPageMCA }
]
